import React, { useEffect, useState } from 'react';
import { messageRed } from '../../../api';
import { IMessageItem, MessageSubType } from '../../../model/api-modules';
import { WindowEvent } from '../../../model';
import { MessageModal } from '../message-center/message-modal';
interface IProps {
  readonly messageList: ReadonlyArray<IMessageItem>;
  readonly unreadMessageList: ReadonlyArray<IMessageItem>;
  readonly getUnreadMessageList: () => void;
}

export const PermissionMessageContent = (props: IProps) => {
  // 查看的 未读消息
  const [unreadMessage, setUnreadMessage] = useState<IMessageItem | null>(null);
  //   const [selectStatus, setSelectStatus] = useState<number>(0); // 0 未读消息  1:全部消息。
  const modalPermissionContent = () => {
    if (unreadMessage) {
      return (
        <MessageModal
          message={unreadMessage}
          onOk={onOk}
          onCloseFail={onCloseFail}
          isClosed={false}
        />
      );
    }
    return null;
  };
  useEffect(() => {
    const firstUnreadMessage = props.messageList?.find((item) => {
      return (
        item.SubType === MessageSubType.PermissionUp ||
        item.SubType === MessageSubType.PermissionDown ||
        item.SubType === MessageSubType.PermissionAdmin ||
        item.SubType === MessageSubType.PermissionUserGroupJoin ||
        item.SubType === MessageSubType.PermissionUserGroupRemove ||
        item.SubType === MessageSubType.PermissionChange ||
        item.SubType === MessageSubType.PermissionScopeChange ||
        item.SubType === MessageSubType.MemberPermissionChange
      );
    });
    if (firstUnreadMessage) {
      if (!firstUnreadMessage.ReadInfo) {
        setUnreadMessage(firstUnreadMessage);
      } else {
        setUnreadMessage(null);
      }
    } else {
      setUnreadMessage(null);
    }
  }, [props.messageList]);

  const onOk = async () => {
    if (unreadMessage) {
      setUnreadMessage(null);
      await messageRed(unreadMessage.id); // 设置为已读
      props.getUnreadMessageList();
      if (
        unreadMessage.SubType === MessageSubType.PermissionChange ||
        unreadMessage.SubType === MessageSubType.PermissionScopeChange
      ) {
        window.location.reload(); // 1057.1058 刷新页面
      }
      window.dispatchEvent(new Event(WindowEvent.PermissionChange));
    }
    return true;
  };

  const onCloseFail = async () => {
    if (unreadMessage) {
      setUnreadMessage(null);
      await messageRed(unreadMessage.id); // 设置为已读
      props.getUnreadMessageList();
    }
    window.dispatchEvent(new Event(WindowEvent.PermissionChange));
  };

  return <>{unreadMessage && modalPermissionContent()}</>;
};
